import type { SelectChangeEvent } from "@mui/material/Select";
import Select from "@mui/material/Select";
import type { FunctionComponent } from "react";

import { useMynewsFeedViewContext } from "scmp-app/components/my-news/feed-view/context";
import type { UserFollowedItem } from "scmp-app/components/my-news/feed-view/type";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";

import { Container, StyledMenuItem, StyledSelectContainer } from "./styles";

export const TopicFilteringSelect: FunctionComponent = () => {
  const { followedList, selectedItem, setSelectedItem } = useMynewsFeedViewContext();

  const onItemChange = (event: SelectChangeEvent) => {
    const value = event.target.value;
    setSelectedItem(JSON.parse(value) as UserFollowedItem);
    sendGA4Tracking({
      action: "click",
      category: "mynews",
      customized_parameters: {
        action_type: "select_section",
        follow_name: selectedItem.name,
        section_type: "topic",
      },
      subcategory: "menu",
    });
  };

  return (
    <Container>
      <StyledSelectContainer>
        <Select
          MenuProps={{
            MenuListProps: {
              sx: {
                paddingBottom: "15px",
                paddingTop: "15px",
              },
            },
          }}
          onChange={onItemChange}
          value={JSON.stringify(selectedItem)}
        >
          <StyledMenuItem
            $isSelected={selectedItem.__typename === "all"}
            value={JSON.stringify({ __typename: "all", entityId: "", entityUuid: "", name: "All" })}
          >
            All
          </StyledMenuItem>
          {followedList.map(item => (
            <StyledMenuItem
              $isSelected={selectedItem.entityId === item.entityId}
              disableRipple
              key={item.entityId}
              value={JSON.stringify(item)}
            >
              {item.name}
            </StyledMenuItem>
          ))}
        </Select>
      </StyledSelectContainer>
    </Container>
  );
};

TopicFilteringSelect.displayName = "TopicFilteringSelect";
